import { DMPrimaryButton } from '@decormatters/dm-theme'

import React, { useEffect, useState } from 'react'
import { logEvent } from '../../../utils/firebase'
import { useRouter as useHistory } from 'next/router'
import { useDispatch } from 'react-redux'
import { BasicDesignCard } from '../../../routes/Profile/components/profile/BasicDesignCard/BasicDesignCard'
import styled from 'styled-components'

const HoverOverlay = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > button {
    @media only screen and (max-width: 600px) {
      font-size: 12px;
      max-width: 85%;
      height: 30px;
      padding: 0 10px;
    }
  }
`

const imgload = async url => {
  const img = new Image()
  img.src = url
  await img.decode()
  return { w: img.width, h: img.height }
}

const DesignDraftCard = ({
  refFn,
  data,
  from,
  onDelete,
  moved,
  mobileGrid,
  mobileGallery,
  ...props
}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [src, setSrc] = useState()

  useEffect(() => {
    if (data.collection) {
      const collection = data.collection
      var url
      if (collection.ext['webp']) {
        url = collection.cdn + collection.key + '-314w.webp'
      } else {
        url = collection.cdn + collection.key + '-314w.jpeg'
      }
      setSrc(url)
    } else if (data.cfThumbImageUrl) setSrc(data.cfThumbImageUrl)
    else if (data.cfBgImageUrl) setSrc(data.cfBgImageUrl)
  }, [data])

  const handleContinue = async e => {
    e.stopPropagation()

    if (moved !== undefined && moved !== 0) return

    logEvent('draft_continue', {
      content_type: 'draft',
      content_id: data.objectId
    })

    if (!data) return

    if (data?.designContest?.objectId) {
      history.push(
        `/create/challenge/${data.designContest.objectId}/${data.objectId}`
      )

      return
    } else if (data?.userEvent?.objectId) {
      history.push(
        `/create/userEvent/${data.userEvent.objectId}/${data.objectId}`
      )

      return
    }

    history.push(`/create/design/${data.objectId}`)
  }

  const handleDelete = e => {
    e.stopPropagation()

    if (onDelete) onDelete(data)
  }

  const menuItems = [
    {
      title: 'Delete',
      onClick: handleDelete,
      highlight: true
    }
  ]

  return (
    <BasicDesignCard
      mobileGallery={mobileGallery}
      mobileGrid={mobileGrid}
      refFn={refFn}
      image={src}
      menuItems={menuItems}
      onClick={handleContinue}
      moved={moved}
      data={data}
      topButtons="menu"
      bottomButtons="none"
      fromOwner
      drafts
      mode="drafts"
      smartSize={false}
      onDelete={onDelete}
      {...props}
    >
      <HoverOverlay>
        <DMPrimaryButton onClick={handleContinue}>
          Continue Design
        </DMPrimaryButton>
      </HoverOverlay>
    </BasicDesignCard>
  )
}

export default DesignDraftCard
